// extracted by mini-css-extract-plugin
export default {"main_card":"ProductCard_main_card__xdvPG","card_action":"ProductCard_card_action__Yh8ES","cart_box":"ProductCard_cart_box__BlXoU","cart_img":"ProductCard_cart_img__Y8YL2"};